var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4859 13.542C27.9504 12.6345 29.6033 10.93 29.9225 7.73291C26.1921 9.65114 24.4331 9.75771 20.8087 7.67908C17.6655 5.76084 11.9635 5.86851 13.6686 9.75771C14.0954 10.9305 15.3748 12.2621 17.0272 13.2728C4.82123 18.4425 0.451921 30.3804 1.14681 38.9064C2.26414 52.0693 36.638 52.9229 39.2489 39.5996C41.2737 29.1026 31.894 16.1002 24.4859 13.542ZM21.2899 36.6146V38.746H19.9034V36.7228C18.6235 36.7228 17.2936 36.296 16.4927 35.8703L17.0272 34.5376C17.7731 34.9628 18.9987 35.3374 20.2231 35.3374C21.876 35.3374 22.8873 34.5904 22.8873 33.4176C22.8873 32.3524 22.0892 31.713 20.3824 31.0753C18.0918 30.2743 16.7069 29.4234 16.7069 27.664C16.7069 26.0643 17.9846 24.7855 20.0633 24.5191V22.4943H21.5025V24.4131C22.8363 24.4669 23.741 24.7861 24.3793 25.1052L23.847 26.3857C23.368 26.1193 22.4611 25.7463 20.9702 25.7463C19.2646 25.7463 18.6235 26.5983 18.6235 27.3964C18.6235 28.4627 19.4244 28.9972 21.3432 29.6893C23.6877 30.5419 24.8583 31.5015 24.8583 33.311C24.8583 34.8579 23.6344 36.2971 21.2899 36.6163V36.6146Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1349 19.3682H12.9961V45.2412H30.1349V19.3682Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7568 41.3652H21.2992L17.0332 35.4111H17.4908L21.7568 41.3652Z",
    fill: "#FFE4C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4923 35.4112H17.0347L15.5449 33.332H16.0025L17.4923 35.4112Z",
    fill: "#FFE4C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0025 31.5938H15.5449V33.3318H16.0025V31.5938Z",
    fill: "#FFE4C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0025 31.5929H15.5449C19.5077 31.5929 20.7031 29.9619 20.7591 28.1689H21.2167C21.1606 29.9619 19.9653 31.5929 16.0025 31.5929Z",
    fill: "#FFE4C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9283 26.6465H15.4707V28.1698H15.9283V26.6465Z",
    fill: "#FFE4C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 26.6459H20.6673C20.408 25.3759 19.3956 24.375 15.4707 24.375H15.9283C19.8526 24.375 20.8656 25.3753 21.1249 26.6459Z",
    fill: "#FFE4C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9283 22.2578H15.4707V24.376H15.9283V22.2578Z",
    fill: "#FFE4C6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.016 22.2575V23.7907H22.1768C22.5921 24.151 22.9689 24.8531 23.2161 25.7171C23.2985 26.0127 23.3694 26.3247 23.4161 26.646H26.0155V28.1693H23.4952C23.3331 31.1999 21.2314 32.3925 19.7944 32.8567C19.0347 33.1006 18.492 33.1374 18.4634 33.139L18.9666 33.8795L24.0714 41.364H21.7571L17.4911 35.4094L16.0013 33.3302V31.5921C19.9642 31.5921 21.1595 29.9612 21.2155 28.1682H15.9277V26.6449H21.1243C20.865 25.3749 19.8526 24.374 15.9277 24.374V22.2559H26.0144L26.016 22.2575Z",
    fill: "#FFE4C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/Banking.cf53b0fe0616b1d3fe223fe21580751b.svg";
export { ForwardRef as ReactComponent };